import { Block, BoundaryParams, Section } from '../types';

export function getInsertionBoundaryForBlock(
  section: Section,
  sectionIndex: number,
  blockId: Block['id']
): BoundaryParams {
  let row = 0;
  let col = 0;
  let block;

  for (let i = 0; i < section.blocks.length; i++) {
    const b = section.blocks[i];
    if (b.id === blockId) {
      block = b;
      break;
    }
    if (b.layout.spec.width === '100%') {
      row++;
      col = 0;
    } else {
      col++;
    }
  }

  return {
    orientation: block?.layout.spec.width === '100%' ? 'horizontal' : 'vertical',
    insertionCol: col,
    insertionRow: row,
    sectionIndex: sectionIndex,

    isFirstInRow: false,
    isFirstInSection: false,
    isLastInRow: false,
    isLastInSection: false,
  };
}
